function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import Dexie from 'dexie';
import { Member as MemberModel, Team as TeamModel, ColumnOrder as ColumnOrderModel, FormResponseDraft as FormResponseDraftModel, ProjectTemplateDraft as ProjectTemplateDraftModel } from './models';
import { CustomerPortalModel } from './models/customer-portal-model';
import { LiveCustomerPortalModel } from './models/live-customer-portal';
export const INDEXED_DB_VERSION = 8.1;
export const INDEXED_DB_NAME = 'RktDb';
export class AppDatabase extends Dexie {
    constructor(){
        super(INDEXED_DB_NAME), _define_property(this, "members", void 0), _define_property(this, "teams", void 0), _define_property(this, "columnOrder", void 0), _define_property(this, "formResponseDraft", void 0), _define_property(this, "templateDraft", void 0), _define_property(this, "customerPortal", void 0), _define_property(this, "liveCustomerPortal", void 0);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const db = this;
        // Define tables and indexes
        // https://stackoverflow.com/questions/60087180/with-dexie-can-i-get-all-objects-in-a-table-where-an-array-field-has-a-specific
        db.version(INDEXED_DB_VERSION).stores({
            members: 'userId, userType, userStatus, *projectIds, company.companyId',
            teams: 'teamId, teamName',
            columnOrder: 'key, orderType',
            formResponseDraft: 'formInstance',
            templateDraft: 'templateId',
            customerPortal: 'customerPortalId',
            liveCustomerPortal: 'id'
        });
        db.members.mapToClass(MemberModel);
        db.teams.mapToClass(TeamModel);
        db.columnOrder.mapToClass(ColumnOrderModel);
        db.formResponseDraft.mapToClass(FormResponseDraftModel);
        db.templateDraft.mapToClass(ProjectTemplateDraftModel);
        db.customerPortal.mapToClass(CustomerPortalModel);
        db.liveCustomerPortal.mapToClass(LiveCustomerPortalModel);
    }
}
export const db = new AppDatabase();
